import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { DocsLayout } from '@/components/docs/DocsLayout';
import { Loader2 } from 'lucide-react';

// Lazy load documentation pages
const DocsHome = React.lazy(() => import('@/pages/docs/DocsHome'));
const DocsPage = React.lazy(() => import('@/pages/docs/DocsPage'));

function DocsLoader() {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}

/**
 * Documentation routes with proper nested routing
 * This provides a file-based routing system for markdown documentation
 */
export const docsRoutes = (
  <Route path="/docs" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsHome /></Suspense></DocsLayout>}>
    {/* Home page */}
    <Route index element={<Suspense fallback={<DocsLoader />}><DocsHome /></Suspense>} />

    {/* Specific documentation pages */}
    <Route path="api-reference" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />
    <Route path="chat-architecture" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />
    <Route path="usage-examples" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />

    {/* Getting Started */}
    <Route path="getting-started/installation" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />
    <Route path="getting-started/creating-first-chatbot" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />

    {/* Project Overview */}
    <Route path="project-overview/introduction" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />
    <Route path="project-overview/architecture-overview" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />

    {/* Technical Architecture */}
    <Route path="technical-architecture/frontend-architecture" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />
    <Route path="technical-architecture/backend-services" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />

    {/* Integration Guides */}
    <Route path="integration-guides/embedding-chat-widget" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />
    <Route path="integration-guides/webhook-integration" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />
    <Route path="integration-guides/pii-integration" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />

    {/* Advanced Features */}
    <Route path="advanced-features/ai-response-validation" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />
    <Route path="advanced-features/pii-handling" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />
    <Route path="advanced-features/streaming-responses" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />
    <Route path="advanced-features/webhook-system" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />

    {/* Customization */}
    <Route path="customization/theming-system" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />
    <Route path="customization/rich-media" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />

    {/* Troubleshooting */}
    <Route path="troubleshooting/common-issues" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />

    {/* Catch-all for any other docs pages */}
    <Route path="*" element={<DocsLayout><Suspense fallback={<DocsLoader />}><DocsPage /></Suspense></DocsLayout>} />
  </Route>
);

export default docsRoutes;
